import AddService from "../pages/service/AddService";

export const all_routes = {
    //Home

    home1: "/index",
    home2: "/index-2",
    home3: "/index-3",
    home4: "/index-4",
    home5: "/index-5",
    home6: "/index-6",

    // Auth
    login: "/login",
    register: "/register",
    forgotPassword: "/forgot-password",
    changepassword: "/change-password",

    // Admin Panel
    adminPanel: "/admin/dashboard",
    adminUsers: "/admin/admin-users",
    servicesAdmin: "/admin/services",
    adminEmpresas: "/admin/empresas",
    adminComissaoEmpresa: "/admin/ComissaoEmpresa",
    adminVeiculos: "/admin/admin-veiculos",
    adminTickets: "/admin/tickets",
    adminProdutos: "/admin/produtos",
    adminPacotes: "/admin/pacotes",
    adminPacotesCompras: "/admin/pacote-compras",
    adminAvaliacoes: "/admin/avaliacoes",
    adminPostagens: "/admin/postagens",

    // Partners / Services
    partners: "/partners",
    addPartner: "/partners/add",
    services: "/services",
    addService: "/service/add",

    // OAuth
    oauth2Redirect: "/oauth2/redirect",

    //Flight
    addFlight: "/flight/add-flight",
    flightGrid: "/flight/flight-grid",
    flightList: "/flight/flight-list",
    flightDetails: (id?: number | string) => id ? `/flight/flight-details/${id}` : "/flight/flight-details",
    flightBooking: "/flight/flight-booking/:id",
    flightBookingConfirmation: "/flight/flight-booking-confirmation",


    //Hotel
    addHotel: "/hotel/add-hotel",
    hotelGrid: "/hotel/hotel-grid",
    hotelList: "/hotel/hotel-list",
    hotelMap: "/hotel/hotel-map",
    hotelDetails: "/hotel/hotel-details",
    hotelBooking: "/hotel/hotel-booking",
    hotelBookingConfirmation: "/hotel/hotel-booking-confirmation",

    //Car
    addCar: "/car/add-car",
    carGrid: "/car/car-grid",
    carList: "/car/car-list",
    carMap: "/car/car-map",
    carDetails: "/car/car-details",
    carBooking: "/car/car-booking",
    carBookingConfirmation: "/car/car-booking-confirmation",

    //cruise
    addCruise: "/cruise/add-cruise",
    cruiseGrid: "/cruise/cruise-grid",
    cruiseList: "/cruise/cruise-list",
    cruiseDetails: "/cruise/cruise-details",
    cruiseBookingConfirmation: "/cruise/cruise-booking-confirmation",
    cruiseBooking: "/cruise/cruise-booking",
    cruiseMap: "/cruise/cruise-map",
    //tour
    addTour: "/tour/add-tour",
    editTour: "/tour/edit-tour",
    tourGrid: "/tour/tour-grid",
    tourList: "/tour/tour-list",
    tourMap: "/tour/tour-map",
    tourBooking: "/tour/tour-booking",
    tourBookingConfirmation: "/tour/tour-booking-confirmation",
    tourDetails: "/tour/tour-details",
    //Agent 
    agentDashboard: "/agent/agent-dashboard",
    agentListing: "/agent/agent-listings",
    editHotel: "/edit-hotel",
    editCar: "/edit-car",
    editFlight: "/edit-flight",
    editCruise: "/edit-cruise",
    agentHotelBooking: "/agent/agent-hotel-booking",
    agentCarBooking: "/agent/agent-car-booking",
    agentCruiseBooking: "/agent/agent-cruise-booking",
    agentTourBooking: "/agent/agent-tour-booking",
    agentFlightBooking: "/agent/agent-flight-booking",
    agentEnquirers: "/agent/agent-enquirers",
    agentEarnings: "/agent/agent-earnings",
    agentReview: "/agent/agent-review",
    agentSettings: "/agent/agent-settings",
    agentNotification: "/agent/agent-notifications",
    agentChat: "/agent/agent-chat",
    agentEnquiriesDetails: "/agent/agent-enquiry-details",
    agentAccountSettings: "/agent/agent-account-settings",
    agentSecuritySettings: "/agent/agent-security-settings",
    agentPlanSettings: "/agent/agent-plans-settings",
    agentPlan: "/agent/agent-plans",
    agentDrivers: "/agent/drivers",
    agentVehicles: "/agent/vehicles",
    agentContract: "/agent/company-contract",
    agentServiceEnrollment: "/agent/service-enrollment",
    agentTukTukBooking: "/agent/agent-tuktuk-booking",


    //User DashBoard
    userDashboard: "/user/dashboard",
    userPreferences: "/user/dashboard/preferences",

    payment: "/user/payment",
    customerHotelBooking: "/user/customer-hotel-booking",
    userMyProfile: "/user/my-profile",
    userProfileSettings: "/user/profile-settings",
    chat: "/user/chat",


    userTukTukBooking: "/user/customer-tuktuk-booking",
    userChat2: "/user/chat/:compraId",

    userFlightBooking: "/user/customer-flight-booking",
    userCarBooking: "/user/customer-car-booking",
    userCruiseBooking: "/user/customer-cruise-booking",
    userHotlesBooking: "/user/customer-hotel-booking",

    userTourBooking: "/user/customer-tour-booking",
    userReviews: "/user/review",
    userChat: "/user/chat",
    userWishlist: "/user/wishlist",
    userWallet: "/user/wallet",
    myProfile: "/user/my-profile",
    profileSettings: "/user/profile-settings",
    notification: "/user/notifications",
    securitySettings: "/user/security-settings",
    notificationSettings: "/user/notification-settings",
    integrationSettings: "/user/integration-settings",
    userSupport: "/user/user-support",
    feed: "/user/feed",
    userFeedExplore: "/user/feed/explore",
    minhasPostagens: "/user/feed/minhas-postagens",


    //Pages

    wishlist: "/wishlist",
    becomeAnExpert: "/become-an-expert",
    privacyPolicy: "/pages/privacy-policy",
    termsConditions: "/terms-conditions",
    contactUs: "pages/contact-us",
    blogList: "/blog/blog-list",
    blogGrid: "blog/blog-grid",
    blogDetails: "blog/blog-details",
    destination: "/pages/destination",
    about_us: "/pages/about-us",
    teams: "/pages/team",
    invoices: "/pages/invoices",
    Gallery: "/pages/gallery",
    Testimonials: "/pages/testimonials",
    FAQ: "/pages/faq",
    pricingPlan: "/pages/pricing-plan",
    Error404: "/pages/error-404",
    Error500: "/pages/error-500",
    underMaintenance: "/pages/under-maintenance",
    homeOneRtl: "/pages/rtl",
    comingSoon: "/pages/coming-soon",

    //Drivers
    driverDashboard: "/driver/dashboard",
    driverProfile: "/driver/profile",
    driverTours: "/driver/tours",
    driverChat: "/driver/chat/:compraId",


};
